<ion-content [fullscreen]="true" class="forgot-content">
  <app-kz-auth-shell>
    <!-- kz2 F1: the slot-based shell. Identity is projected, never passed as inputs (D12c). -->
    <app-kz-brand-lockup appbar [showStrapline]="false"></app-kz-brand-lockup>
    <app-kz-brand-lockup pitchTop [onPrimary]="true" [showStrapline]="false"></app-kz-brand-lockup>
    <div pitchLead>
      <p class="pitch__p">{{ $any(appEnv).appStatement | inlinetranslate }}</p>
    </div>

    <div class="auth-form">
      <header class="auth-form__head">
        <h1>{{ 'app.pages.forgot.title' | translate }}</h1>
        <p>{{ 'app.pages.forgot.subtitle' | translate }}</p>
      </header>

      @if (!sent) {
        <form [formGroup]="form">
          <app-kz-form-field
            [label]="'app.pages.forgot.email' | translate"
            type="email"
            inputmode="email"
            [control]="$any(form.get('email'))"
          ></app-kz-form-field>

          <ion-button
            class="auth-form__submit"
            expand="block"
            [disabled]="isSubmitting"
            (click)="submit()"
          >
            <ion-icon slot="start" name="mail-outline"></ion-icon>
            {{ (isSubmitting ? 'app.pages.forgot.sending' : 'app.pages.forgot.action') | translate }}
          </ion-button>
        </form>
        @if (websiteUrl) {
          <app-kz-inline-alert role="alert" tone="stop" icon="alert-circle-outline" [heading]="'app.pages.forgot.appCheck.title' | translate">
            {{ 'app.pages.forgot.appCheck.body' | translate }}
            <ion-button class="website" size="small" fill="outline" type="button" (click)="openWebsite()">
              <ion-icon slot="start" name="open-outline" aria-hidden="true"></ion-icon>
              {{ 'app.pages.forgot.appCheck.action' | translate }}
            </ion-button>
          </app-kz-inline-alert>
        }
      } @else {
        <div class="forgot-sent">
          <ion-icon name="mail-open-outline"></ion-icon>
          <b>{{ 'app.pages.forgot.sentTitle' | translate }}</b>
          <span>{{ 'app.pages.forgot.sentBody' | translate }}</span>
        </div>
      }

      <p class="auth-form__alt">
        <a tappable (click)="backToLogin()">{{ 'app.pages.forgot.back' | translate }}</a>
      </p>
    </div>
  </app-kz-auth-shell>
</ion-content>
